export default function highlightText(
  str: string,
  text: string,
  onlyLast: boolean = false
) {
  const SEPARATOR = '\u241D'; // some fairly unused unicode char
  if (!text || !str || str.includes(SEPARATOR)) {
    return str;
  }
  const tokens = str
    .replace(new RegExp(`(${text})`, 'gi'), `${SEPARATOR}$1${SEPARATOR}`)
    .split(SEPARATOR)
    .map((token, index) => ({
      value: token,
      key: token + index,
      isMatch: token.toLowerCase() === text.toLowerCase(),
    }));

  if (onlyLast) {
    let lastIndex = -1;
    for (let i = tokens.length - 1; i >= 0; i--) {
      if (tokens[i].isMatch) {
        lastIndex = i;
        break;
      }
    }
    return tokens.map((token, index) => {
      if (index === lastIndex) {
        return <strong key={token.key}>{token.value}</strong>;
      }
      return <span key={token.key}>{token.value}</span>;
    });
  }

  return tokens.map((token) => {
    return token.isMatch ? (
      <strong key={token.key}>{token.value}</strong>
    ) : (
      <span key={token.key}>{token.value}</span>
    );
  });
}
